import ApiClient from '@config/network';
import { useCheckoutConfigContext } from '@contexts/CheckoutConfig';
import { useEffect, useState } from 'react';

interface PayPalButtonOptions {
  clientId: string;
  currency: string;
  merchantId: string;
}

const usePayPalButton = () => {
  const { checkout } = useCheckoutConfigContext();
  const [options, setOptions] = useState<PayPalButtonOptions | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    setLoading(true);
    ApiClient.get<{ client_id: string; merchant_id: string }>(
      `rest/v1/checkout/paypal/${checkout.token}`,
    )
      .then(({ data }) => {
        setOptions({
          clientId: data.client_id,
          currency: 'EUR',
          merchantId: data.merchant_id,
        });
      })
      .catch((err) => {
        setError(err);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [checkout]);

  return { options, loading, error };
};

export default usePayPalButton;
